import { Template } from './../models/templateModel';
import { Dispatch } from "redux";
import { uuid } from "uuidv4";
import { Form } from "../models/formModel";
import { AppState } from "../reducers/rootReducer";
import { ADD_FORM, AppActions, EDIT_FORM, REMOVE_ALL_FORMS, REMOVE_FORM, SET_FORM } from "../types/actions";
import formService from "../services/formService";
import { setRow } from "./rowListAction";
import { setSection } from "./sectionListAction";
import { setElement } from "./elementListAction";
import { setTab } from "./tabListAction";
import produce from "immer";
import { setSession } from "./sessionListAction";
import { SystemTypes } from "../utils/constants";
import rowService from "../services/rowServices";
import sectionService from "../services/sectionService";
import elementService from "../services/elementService";
import tabService from "../services/tabService";
import templateService from '../services/templateService';
import { cssStyle } from '../models/cssStyleModel';
import jsPDF from "jspdf";
import { Element } from "../models/elementModel";

export const addForm = (form: Form): AppActions => ({
  type: ADD_FORM,
  form
});

export const editForm = (form: Form): AppActions => ({
  type: EDIT_FORM,
  form
});

export const removeForm = (id: String): AppActions => ({
  type: REMOVE_FORM,
  id
})

export const setForm = (forms: Form[]): AppActions => ({
  type: SET_FORM,
  forms
})

export const removeAllForms = (): AppActions => ({
  type: REMOVE_ALL_FORMS
})

// start adding form into redux store

export const startAddFrom = (formData: {
  name: string;
  projectId: String;
  type: string;
  modalAttribute?: any;
  alertAttribute?: any;
  createBy?: string;
  saveAs?: string;
  groupId?: string;
  cssStyles?: [any];
  createdTime?: string;
  lastUpdatedTime?: string;
}) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const {
      name = "",
      projectId = "",
      type = "",
      cssStyles = [{ id: "", value: "", retrivedStyle: "", style: "" }],
      modalAttribute = {},
      alertAttribute = {},
      createBy = "user",
      saveAs = "user",
      groupId = "",
      createdTime = "",
      lastUpdatedTime = "",
    } = formData;

    const form = {
      name,
      projectId,
      type,
      modalAttribute,
      alertAttribute,
      createBy,
      saveAs,
      groupId,
      cssStyles,
      createdTime: "",
      lastUpdatedTime: "",
    };
    const id = uuid();

    const { data } = await formService.createForm({
      id,
      ...form,
    });

    dispatch(addForm(data.data));

    // Redirect to created form or modal or alert
    const reduxStore = await formService.getFormById(data.data);
    dispatch(setRow(reduxStore.rowList));
    dispatch(setSection(reduxStore.sectionList));
    dispatch(setElement(reduxStore.elementList));
    dispatch(setTab(reduxStore.tabList));

    let sessionState = getState().session;
    let newSessionState = produce(sessionState, (draft) => {
      draft.selectedFormId = data.data.id;
      draft.selectedType = SystemTypes.FORM;
    });
    dispatch(setSession(newSessionState));
    localStorage.setItem("session", JSON.stringify(newSessionState));
  };
};

// start editing form in redux store

export const startEditForm = (form: Form) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    formService.updateForm(form);
    dispatch(editForm(form));
  };
};

// start remove form from redux store

export const startRemoveForm = (id: String) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const state = getState();
    await formService.deleteForm(id);
    if (state.session.selectedFormId === id) {
      const remainFormList = state.formList.filter((form) => { return form.id !== id });
      let newSessionState = produce(state.session, draft => {
        if (remainFormList.length > 0) { draft.selectedFormId = remainFormList[0].id; }
                else {
          draft.selectedFormId = "";
          draft.selectedType = "";
        }
      });
      dispatch(setSession(newSessionState));
      localStorage.setItem('session', JSON.stringify(newSessionState));
      localStorage.setItem('form', '');
    }
    dispatch(removeForm(id));
  };
};

// start select all forms from redux store

export const startSetForm = (forms: Form[]) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    dispatch(setForm(forms));
  }
}

export const startLoadFormPrev = (form: Form) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const reduxStore = await formService.getFormById(form);
    dispatch(setForm(reduxStore.formList));
    const session = localStorage.getItem("session");
    if (session) {
      dispatch(setSession(JSON.parse(session)));
    }
    let sessionState = getState().session;
    let newSessionState = produce(sessionState, draft => { draft.selectedFormId = form.id; draft.selectedType = SystemTypes.FORM });
    dispatch(setSession(newSessionState));
    dispatch(setRow(reduxStore.rowList));
    dispatch(setSection(reduxStore.sectionList));
    dispatch(setElement(reduxStore.elementList));
    dispatch(setTab(reduxStore.tabList));
    localStorage.setItem('form', JSON.stringify(form));
    localStorage.setItem('session', JSON.stringify(newSessionState));
  
    }
}

export const startLoadForm = (form: Form) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const reduxStore = await formService.getFormById(form);
    dispatch(setRow(reduxStore.rowList));
    dispatch(setSection(reduxStore.sectionList));
    dispatch(setElement(reduxStore.elementList));
    dispatch(setTab(reduxStore.tabList));

    let sessionState = getState().session;
    let newSessionState = produce(sessionState, draft => { draft.selectedFormId = form.id; draft.selectedType = SystemTypes.FORM });
    dispatch(setSession(newSessionState));
    localStorage.setItem('session', JSON.stringify(newSessionState));

  }
}

export const startLoadFormToProtoTypePreview = (form: Form) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const reduxStore = await formService.getFormById(form);
    dispatch(setRow(reduxStore.rowList));
    dispatch(setSection(reduxStore.sectionList));
    dispatch(setElement(reduxStore.elementList));
    dispatch(setTab(reduxStore.tabList));
  }
}

export const downloadRemarkPdf = async (id: string) => {
  if (id) {
    const elementDetails = await formService.getFormElementsById(id);
    const elements: Element[] = elementDetails.elementList;
    if (elements.length === 0) {
      console.log("No elements found in the form.");
      return; 
    }
    const pdf = new jsPDF();
    pdf.setFontSize(15);
    let y = 10;
    let count = 0;

    const formid = `Form Id :  ${elements[0].formId}`;
    pdf.text(formid, 60, y);
    y += 7;

    elements.forEach((element) => {
      const content = [
        `Element ID: ${element.id}`,
        `Element Name: ${element.name}`,
        `Element Type: ${element.type}`,
        `Remark 1: ${element.properties.remark1}`,
        `Remark 2: ${element.properties.remark2}`,
        `Remark 3: ${element.properties.remark3}`,
        `Remark 4: ${element.properties.remark4}`,
      ];

      pdf.setFontSize(10);

      for (let i = 0; i < content.length; i++) {
        pdf.text(content[i], 10, y);
        y += 4;
      }
      y += 3;
      count++;
      if (count === 8) {
        pdf.addPage();
        y = 10;
        pdf.setFontSize(15);
        pdf.text(formid, 60, y);
        count = 0;
        y += 7;
      }
    });

    pdf.save("remarks.pdf");
  } else {
    console.log("form is null");
  }
};




export const startLoadFormDetails = (id: string) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const data = await formService.getFormDetailsById({id: id});
    dispatch(setRow(data.rowList));
    dispatch(setSection(data.sectionList));
    dispatch(setElement(data.elementList));
    dispatch(setTab(data.tabList));
  }
}

export const getSelectedForm = (id: string) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const data = await formService.getFormDetailsByIdForPreview(id);
    dispatch(setForm(data.data.data));
  }
}

export const startLoadFormListByProjectId = (id: string) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const data = await formService.getFormsByProjectId({projectId: id, type:'form'});
    dispatch(setForm(data.formList));
  }
}

// export const startCopyFormPre = (formData: { name: string, projectId: String, type:string, modalAttribute:any, alertAttribute:any }) => {
//     return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
//         const {
//             name = "",
//             projectId = "",
//             type = "",
//             modalAttribute = {},
//             alertAttribute = {},
//         } = formData

//         const form = { name, projectId, type, modalAttribute, alertAttribute }
//         const id = uuid();
//         const { data } = await formService.copyForm({
//             id,
//             ...form
//         });

//         const state = getState();
//         if (state.rowList.length > 0) {
//             const newRowList = produce(state.rowList, draft => { draft.map((row) => { row.formId = id }) })
//             await rowService.copyRows(newRowList);
//         }
//         if (state.sectionList.length > 0) {
//             const newSectionList = produce(state.sectionList, draft => { draft.map((section) => { section.formId = id }) })
//             await sectionService.copySections(newSectionList);
//         }
//         if (state.elementList.length > 0) {
//             const newElementList = produce(state.elementList, draft => { draft.map((element) => { element.formId = id }) })
//             await elementService.copyElements(newElementList);
//         }
//         if (state.tabList.length > 0) {
//             const newTabList = produce(state.tabList, draft => { draft.map((tab) => { tab.formId = id }) })
//             await tabService.copyTabs(newTabList);
//         }

//         dispatch(
//             addForm(data.data)
//         );
//     }
// }

export const startCopyForm = (formId:String, createBy: string, saveAs: string) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const state = getState();
    const id = uuid();
    const form = produce(state.formList.filter((form) => { return form.id === formId})[0], draft => { draft.id = id; draft.name = `${draft.name} ${saveAs}`;})
    const { data } = await formService.copyForm({ form : form, createBy: createBy , saveAs: saveAs});
    if (state.rowList.length > 0) {
      const newRowList = produce(state.rowList, draft => { draft.map((row) => { row.formId = id }) })
      await rowService.copyRows(newRowList);
    }
    if (state.sectionList.length > 0) {
      const newSectionList = produce(state.sectionList, draft => { draft.map((section) => { section.formId = id }) })
      await sectionService.copySections(newSectionList);
    }
    if (state.elementList.present.length > 0) {
      const newElementList = produce(state.elementList.present, draft => { draft.map((element) => { element.formId = id }) })
      await elementService.copyElements(newElementList);
    }
    if (state.tabList.length > 0) {
      const newTabList = produce(state.tabList, draft => { draft.map((tab) => { tab.formId = id }) })
      await tabService.copyTabs(newTabList);
    }

    dispatch(
            addForm(data.data)
        );

    // Redirect to created form or modal or alert
    const reduxStore = await formService.getFormById(data.data);
    dispatch(setRow(reduxStore.rowList));
    dispatch(setSection(reduxStore.sectionList));
    dispatch(setElement(reduxStore.elementList));
    dispatch(setTab(reduxStore.tabList));

    let sessionState = getState().session;
    let newSessionState = produce(sessionState, draft => { draft.selectedFormId = data.data.id; draft.selectedType = SystemTypes.FORM });
    dispatch(setSession(newSessionState));
    localStorage.setItem('session', JSON.stringify(newSessionState));
  }
}

export const startSaveTemplate = () => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const state =getState();
    const template:Template = { name:'login-template',rowList:state.rowList, elementList:state.elementList.present, sectionList:state.sectionList, tabList:state.tabList}
    const { data } = await templateService.createTemplate(template);
  }
}